module.exports = __webpack_public_path__ + "img/D202011_2.66cb2401.jpg";